const formatVehicleComment = (extItem) => {
  const { description } = extItem.data;
  return description;
};
export {
  formatVehicleComment
};
